import { Component, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DocumentStateService } from '../services/document-state.service';
import { Subscription } from 'rxjs';
import { PermissionService, TokenService } from '../../../core/services';

@Component({
  selector: 'app-document-reviewed',
  standalone: false,
  template: '',
})
export class DocumentReviewedAuthentication {
  route = inject(ActivatedRoute);
  router = inject(Router);

  $subscription = new Subscription();

  constructor(
    private documentState: DocumentStateService,
    private permissionService: PermissionService,
    private tokenService: TokenService,
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      const {
        token,
        clientId,
        partNumber,
        serialNumber,
        componentId,
        userLevel,
        isCookiesLogin,
      } = params;
      const isCookieBasedLogin =
        isCookiesLogin === 'true' || isCookiesLogin === true;

      if (userLevel) {
        localStorage.setItem('userLevel', userLevel);
      } else {
        this.$subscription.add(
          this.permissionService.getUserProfile().subscribe({
            next: (res) => {
              localStorage.setItem('userLevel', res.data.level);
            },
          }),
        );
      }

      if (clientId) {
        localStorage.setItem('clientId', clientId);
      }

      if (isCookieBasedLogin && !token) {
        this.tokenService.clearAuthTokens();
      }

      this.tokenService.setCookiesLogin(isCookieBasedLogin);

      if (!isCookieBasedLogin && token) {
        localStorage.setItem('X-Access-Token', token);
        this.documentState.setDocumentInfo({
          token,
          clientId,
          componentId,
          partNumber,
          serialNumber,
        });
        document.cookie = `x-access-token=${token}; Path=/; Secure; SameSite=None; Max-Age=86400`;
      }
      if (isCookieBasedLogin || token) {
        this.router.navigate(['/home'], {
          queryParams: {
            token: isCookieBasedLogin ? undefined : token,
            clientId,
            partNumber,
            serialNumber,
            componentId,
            isCookiesLogin: isCookieBasedLogin,
          },
        });
      } else {
        this.router.navigate(['/auth/login']);
      }
    });
  }
}
